(function() {
    'use strict';

    angular
        .module('app')
        .controller('tsunMyTrainingController', tsunMyTrainingController);

    function tsunMyTrainingController($q, ssoInfo, $rootScope, $timeout, $scope, modalService) {
        var vm = this;
        //==Main==
        onInit();
        //========
        function onInit() {
            vm.method = methodList();
            vm.view = viewInit();
            vm.data = dataInit();
            logicInit();
        }

        function dataInit() {
            var result = {
                ssoInfo: null,
                translate: $rootScope.translate
            };
            return result;
        }

        function viewInit() {
            var result = {
                pageLoading: false, //.........頁面讀取中
                pageLoaded: false, //..........頁面讀取完畢
                menuType: 1, //................選單顯示樣式(磚塊[1]或是下拉[2])
                isMobile: modalService.isMobile(),
            };
            return result;
        }

        function methodList() {
            var result = {
                menuClick: menuClick,
            };
            return result;
        }

        function logicInit() {
            // console.log("ssoInfo:", ssoInfo);
            vm.menuIndex = 0;
            vm.menuList = [];
            vm.view.pageLoading = true;
            return $q.when(menuLoad()).then(function() {
                vm.view.pageLoading = false;
                vm.view.pageLoaded = true;
                vm.menuSeletedText = vm.menuList[0].name;
                if (ssoInfo) {
                    vm.data.ssoInfo = ssoInfo;
                } else {
                    //另外取得使用者資訊。
                }
                $scope.$watch('isSmallView', function(newValue, oldValue) {
                    if (newValue === oldValue) { return; }
                    menuNameEdit();
                });
            });
        }

        function menuLoad() {
            vm.menuList = [
                { id: 1, name: '', nameValue: $rootScope.translate.tsunRepairProject },
                { id: 2, name: '', nameValue: $rootScope.translate.tsunCourseLog },
                { id: 3, name: '', nameValue: $rootScope.translate.tsunFinancial },
                { id: 4, name: '', nameValue: $rootScope.translate.tsunExterior },
                { id: 5, name: '', nameValue: $rootScope.translate.tsunBankBook }
            ];
            menuStyleChange();
            menuNameEdit();
        }

        function menuStyleChange() {
            var langSelected = sessionStorage.getItem('langCode');
            switch (langSelected) {
                case '1':
                case '2':
                    vm.view.menuType = 1;
                    break;
                default:
                    vm.view.menuType = 2;
                    break;
            }

        }

        function menuClick(index) {
            vm.menuIndex = index;
            //console.log('menuIndex:', vm.menuIndex);
        }


        function menuNameEdit() {
            if (vm.menuList.length < 1) { return; }
            var langSelected = sessionStorage.getItem('langCode');
            _.forEach(vm.menuList, function(menuItem) {
                var nameLength = menuItem.nameValue.length;
                var position = 0;
                if (!$rootScope.isSmallView) {
                    menuItem.name = menuItem.nameValue;
                    return;
                }
                switch (langSelected) {
                    case '1':
                    case '2':
                        //中文處理
                        var numLineChange = 2;
                        menuItem.name = '';
                        do {
                            if ((nameLength - position) > numLineChange) {
                                menuItem.name += menuItem.nameValue.substr(position, numLineChange);
                                menuItem.name += '<br/>';
                            } else {
                                menuItem.name += menuItem.nameValue.substr(position, (nameLength - position));
                            }
                            position += numLineChange;
                        } while ((nameLength - position) > 0);
                        break;
                    default:
                        menuItem.name = menuItem.nameValue;
                        //外語處理
                        break;
                }
            });

        }

        /* 漢堡選單click事件 */
        var menuSerilNo = parseInt(getMenuQueryString());
        //console.log('train index menu:', menuSerilNo);
        //待修
        if (menuSerilNo === -9901) {
            menuClick(0);
        }
        //修課紀錄
        if (menuSerilNo === -9906) {
            menuClick(1);
        }
        //金融 先跳過
        if (menuSerilNo === -9991 || menuSerilNo === -9992 || menuSerilNo === -9993) {
            menuClick(2);
        }
        //外訓
        if (menuSerilNo === -9904) {
            menuClick(3);
        }
        //存摺
        if (menuSerilNo === -9907) {
            menuClick(4);
        }
    }
})();